export * from './app-configs.js';
//# sourceMappingURL=index.js.map